import React from "react";
import Button from "./Button";
import "./ButtonSegments.scss"
import classNames from "classnames";
import { ternaryCheck } from "../../../Utils/WindowUtils";

interface ButtonSegmentsInterface {
    buttonData?: any;
    handleClick: () => void;
    icon?: any;
    isActive?: boolean;
    adaRole?: string;
    ariaLabel?: string
}

const ButtonSegments: React.FC<ButtonSegmentsInterface> = ({
  buttonData,
  handleClick,
  icon,
  isActive,
  adaRole = 'tab',
  ariaLabel = ternaryCheck(!!isActive, ``, `${buttonData.title} not selected`)
}) => {
 
  return (
    <Button
      className={classNames('button_segment', {
        'button_segment--selected': isActive,
      })}
      testAutoId={buttonData.title}
      onClick={() => handleClick()}
      role={adaRole}
      aria-selected={isActive}
      aria-label={ariaLabel}
      icon={icon}
    >
      {buttonData.title}
    </Button>
  );
};

export default ButtonSegments;

